import * as React from 'react';
import { useState } from 'react';
import { Parallax } from 'react-scroll-parallax';
import { ResponsiveContainer, ComposedChart, Bar, Line, CartesianGrid, YAxis, XAxis, Tooltip, Legend, Surface, Symbols } from 'recharts';
import VisibilitySensor from 'react-visibility-sensor';

import './style.scss';

import content from './content.json';

const formatYAxis = (tickItem) => {
  return tickItem.toLocaleString();
};

const renderTooltip = (props) => {
  // console.log(props);
  const { payload, label } = props;

  return (
    <div style={{
      margin: 0,
      padding: "10px",
      background: "rgb(255, 255, 255)",
      border: "1px solid rgb(204, 204, 204)",
      whiteSpace: "nowrap"
    }}>
      <p className={"recharts-tooltip-label"} style={{
        margin: 0
      }}>{label}</p>
      <ul style={{
        listStyle: "none",
        margin: 0,
        padding: 0
      }}>
        {
          payload.map((entry, index) => {
            // console.log(entry);
            return (
            <li key={`item-${index}`}
              style={{
                marginBottom: "4px",
                width: "100%",
                fontSize: "14px",
                whiteSpace: "normal"
              }}>
              <Surface width={14} height={14} viewBox="0 0 10 10">
                <Symbols cx={5} cy={5} fill={entry.color} />
              </Surface>
              {entry.name}: {entry.value.toLocaleString()}
            </li>
            )
          })
        }
      </ul>
    </div>
  );
}

const ChartSection = () => {
  const { description, chartData, barsLabel, lineLabel } = content;

  const [visible, setVisible] = useState(false);

  return (
    <section className="l-chart-section">
      <Parallax className="background" y={[-30, 30]}>
        <div className="bg1" />
        <div className="bg2" />
      </Parallax>

      <div className="container">
        <p>{description}</p>

        <VisibilitySensor
          partialVisibility
          onChange={(isVisible) => {
            setVisible(isVisible);
          }}
          >
          <div className="chart">
            <ResponsiveContainer width="100%" height={430}>
              <ComposedChart width={820} height={430} data={chartData}>
                <XAxis tickMargin={14} dataKey="name" />
                <YAxis width={80} yAxisId="left" tickFormatter={formatYAxis} tickMargin={14} type="number" tickCount={17} interval={0} domain={[10000, 90000]} scale="linear" />
                <YAxis yAxisId="right" tickMargin={14} type="number" tickCount={10} interval={0} domain={[0, 20]} scale="linear" orientation="right" />
                {/* <Tooltip /> */}
                <Tooltip content={renderTooltip}/>
                <Legend wrapperStyle={{ position: 'relative', marginTop: '1rem' }} />
                <CartesianGrid stroke="#004952" strokeOpacity={0.5} vertical={false} />
                <Bar 
                  yAxisId="left"
                  hide={!visible}
                  isAnimationActive={true}
                  animationDuration={2000}
                  name={barsLabel} 
                  dataKey="participants"
                  barSize={20}
                  fill="#EB7323" />
                {visible &&
                  <Line
                    yAxisId="right"
                    isAnimationActive={true}
                    animationDuration={2000}
                    name={lineLabel}
                    type="linear"
                    dataKey="schemes"
                    stroke="#07BCC7"
                    strokeWidth={2}
                    dot={{ fill: '#07BCC7' }}
                  />
                }
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </VisibilitySensor>
      </div>
    </section>
  );
};

export default ChartSection;
